import { z } from 'zod';
import { TYPES } from './comment.types';
export const formKey = {
    date: 'date',
    text: 'text',
    type: 'type',
    tags_id: 'tags_id',
};
export const getFormSchema = (meetingStartDate, meetingEndDate) => z
    .object({
    date: z
        .union([z.string(), z.date()])
        .transform(arg => (arg instanceof Date ? arg : new Date(arg)))
        .refine(date => {
        return (date >= meetingStartDate && date <= meetingEndDate);
    }, { message: "La date n'est pas pendant la durée du stage" }),
    text: z.string({
        required_error: "Merci d'ajouter une observation avant de le publier",
    }),
    type: z.enum(TYPES),
    tags_id: z.array(z.string().min(1, 'Ce champ est obligatoire').max(50)),
})
    .refine(({ text, tags_id }) => {
    return text.length > 0 || tags_id.length > 0;
}, {
    message: "Merci d'ajouter une observation (ou un tag) avant de publier",
    path: ['text', 'tags_id'],
})
    .refine(({ text, type }) => type !== 'avis' || text.length <= 1000, {
    message: "L'avis doit faire moins de 1000 caractères",
});
//# sourceMappingURL=comment.form.js.map